import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/call-intelligence.webp';

const thumbHashString = 'qdeFCoI79iiMcYj9XJPIAQhIdHZ1aGg=';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 2.218905472636816;
const originalWidth = 446;

const CallIntelligence = ({ aspectRatio = calculatedAspectRatio, width = originalWidth, ...rest }: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default CallIntelligence;
